(function () {

  const drawer = document.querySelector('.addon-drawer');
  const backdrop = document.querySelector('.addon-drawer-backdrop');
  const closeBtn = document.querySelector('.addon-drawer__close');

  if (!drawer || !backdrop) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ================= OPEN ADDON DRAWER ================= */

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-addon-open');
    if (!trigger) return;

    e.preventDefault();
    openDrawer();
  });

  /* ================= CLOSE ================= */

  closeBtn?.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ================= VARIANT CHANGE ================= */

  document.addEventListener('change', function (e) {
    const select = e.target.closest('.addon-item-drawer__variant');
    if (!select) return;

    const item = select.closest('.addon-item-drawer');
    const priceEl = item.querySelector('[data-addon-price]');
    const addBtn = item.querySelector('.addon-item-drawer__add');

    const option = select.selectedOptions[0];

    if (priceEl && option.dataset.price) {
      priceEl.innerHTML = option.dataset.price;
    }

    if (addBtn) {
      addBtn.disabled = option.dataset.available === 'false';
    }
  });

  /* ================= ADD TO CART ================= */

  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.addon-item-drawer__add');
    if (!addBtn) return;

    e.preventDefault();

    const item = addBtn.closest('.addon-item-drawer');
    const select = item.querySelector('.addon-item-drawer__variant');

    const variantId = select
      ? select.value
      : addBtn.dataset.variantId;

    if (!variantId) {
      console.error('Missing variant ID');
      return;
    }

    const btnLoad = addBtn.querySelector('.add-loader');

    if (btnLoad) btnLoad.style.display = "inline-block";

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(() => {
        closeDrawer();

        // Tell Prestige to reload cart sections
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Open cart drawer after refresh
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            cartDrawer.setAttribute('open', '');
        }
        })
    .catch(err => {
      console.error('Addon add failed', err);
      if (btnLoad) btnLoad.style.display = "none";
    });
  });

})();
